import { render } from "./DesignSVGText.vue?vue&type=template&id=aa638ffe&scoped=true"
import script from "./DesignSVGText.vue?vue&type=script&lang=js"
export * from "./DesignSVGText.vue?vue&type=script&lang=js"

import "./DesignSVGText.vue?vue&type=style&index=0&id=aa638ffe&lang=css"
import "./DesignSVGText.vue?vue&type=style&index=1&id=aa638ffe&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-aa638ffe"]])

export default __exports__